'use client';

import { c as _c } from "react/compiler-runtime";
import { isOperatorDriveName } from '@achra/sdk';
import { useUserDrives } from '@/modules/shared/hooks/use-user-drives';

/**
 * Resolves the current user's operator/service-offering drive — the drive whose
 * name carries the canonical "Service Offering" suffix.
 *
 * The presence of this drive is the SDK's own definition of "is an operator"
 * (`roles.operator.detect`), so `hasOperatorDrive` is the authoritative operator
 * signal — no separate `isOperator` profile read is needed. Reads the same
 * cached `useUserDrives` query as `useTeamAdminDrive`, so it adds no extra fetch.
 */
function useOperatorDrive() {
  const $ = _c(6);
  const drivesQuery = useUserDrives();
  let t0;
  if ($[0] !== drivesQuery.data) {
    t0 = drivesQuery.data?.find(_temp);
    $[0] = drivesQuery.data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const operatorDrive = t0;
  const t1 = Boolean(operatorDrive);
  let t2;
  if ($[2] !== drivesQuery || $[3] !== operatorDrive || $[4] !== t1) {
    t2 = {
      drivesQuery,
      operatorDrive,
      hasOperatorDrive: t1
    };
    $[2] = drivesQuery;
    $[3] = operatorDrive;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(drive) {
  return isOperatorDriveName(drive.driveName);
}
export { useOperatorDrive };